import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import type { EnvironmentProviders } from '@angular/core';

export const provideTheme = (): EnvironmentProviders => providePrimeNG({
    theme: {
        preset: Lara,
        options: {
            prefix: '',
            // disable dark mode
            darkModeSelector: false,
            cssLayer: {
                name: 'primeng',
                order: 'reset, primeng, framework, base, layout, components, utilities',
            },
        },
    },
    // eslint-disable-next-line @stylistic/max-len
    license: 'eyJpZCI6IjYwNWI0ZmNhLWY3MjAtNDQwYS1iMzFjLTFkMjcyMDZkZmZhMCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzg2NDQ5MjIxLCJleHAiOjE4MTc5Nzg2NDl9.Uh8Z30bmfZvv2hiIaelWjTg2C-Mj42vLTHbHWXAz6Ytw436VtvPTf7_6Ji1KXwaLmlRLySXDlSUyBwGirldyBA',
    translation: {
        aria: {
            maximizeLabel: 'Vollbild umschalten',
        },
    },
});
